export default __webpack_public_path__ + "static/media/infografico_5_CAMPOS_DE_EXPERIENCIA_bncc.ae561344.png";